/*
 * Copyright (c) 2021.
 * 2iPartners SàRL and/or its affiliates.
 * All rights reserved.
 *
 * 2iPartners SàRL
 * Route de Compois 24,
 * 1252 Meinier
 * Suisse
 *
 * tel : +41 22 735 97 07
 */

/**
 * Proval API
 * This is the Proval API!
 *
 * OpenAPI spec version: 0.1.0-alpha.182
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import {Links} from './links';


export interface PhoneNumber {
  id: number;
  fax: boolean;
  name: string;
  number: string;
  type: number;
  _links?: Links;
}

export enum PhoneNumberTypes {
  MOBILE = 1,
  PHONE = 0
}

export function PHFromString(number: string, isMobilePhone: boolean): PhoneNumber {
  return {
    id: null,
    fax: false,
    name: null,
    number: number,
    type: isMobilePhone ? PhoneNumberTypes.MOBILE : PhoneNumberTypes.PHONE
  };
}
